import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";

import { Card, CardBody, Row, Col, Button, Alert } from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import "../../styles/estilos.css";
import Page from "components/Page";
import { Textbox } from "react-inputs-validation";

import {
  fetchProcesoCarritoAccP,
  fetchRecuperarCarritoAccP,
} from "../../redux/actions/aRamoAccidentesPersonales";
import AccPersonalTooltip from "../Widget/tooltips/AccPersonalTooltip";

class CotizacionAccPersonal2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      numDias: "",
      hasNumDiasError: true,
      selPlan: false,
      idPlan: "",
      numPersonas: "",
      estructura: {},
      loading: true,
      errorCantidad: false,
      idCarrito: "",
      mostrarDistribucionPersonas: "",
      optionSelected: undefined,
      countValores: 0
    };

    this.onClickRegresar = this.onClickRegresar.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.asignarNumeroPersonas = this.asignarNumeroPersonas.bind(this);
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  async validateForm(e, valor = null) {
    e.preventDefault();
    this.toggleValidating(true);

    let numPersonasCont = this.state.numPersonas;
    let estructura = this.state.estructura.datosPersonas;

    let nombreProducto = (this.props.datosRecuperarCarritoAccP && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP) ? this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carDescripcionSeguro : ''
    let nombreProducto2 = this.props.datosRecuperarCarritoAccP &&
      this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP &&
      this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .carProductos &&
      this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .carProductos[0] &&
      this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .carProductos[0].plan ?
      this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .carProductos[0].plan.descripcion : ''


    let sumatoria = 0;
    estructura.map((seccion) => {
      seccion.valores.map((valor) => {
        sumatoria += parseInt(valor.numPersonas);
      });
    });

    let continuar = true;

    //validar para el caso de distribucion y caso contrario
    if (
      this.state.mostrarDistribucionPersonas &&
      this.state.mostrarDistribucionPersonas === "1"
    ) {
      if (sumatoria < numPersonasCont || sumatoria > numPersonasCont) {
        continuar = false;
      }
      if (!parseInt(sumatoria)) {
        continuar = false;
      }
    }
    debugger
    let EstructuraEnviar = this.state.estructura;
    //Reemplazar el array de distribucion por el producto seleccionado
    if (this.state.mostrarDistribucionPersonas === "2" && valor !== null) {
      EstructuraEnviar.datosPersonas.map((seccion) => {
        seccion.valores.map((v) => {
          if (parseInt(v.codOpcion) === parseInt(valor)) {
            v.productoseleccionado = true;
          } else {
            delete v.productoseleccionado;
          }
        });
      });

      //console.log('CONTINUAAAA2',  EstructuraEnviar.datosPersonas[0].valores)
    }
    if (continuar === true) {
      console.log("go to resumen", this.state.idCarrito);
      await this.props.procesoCarrito(EstructuraEnviar);

      if (
        !this.props.datosProcesoCarritoAccP.procesoCarritoAccPIsLoading &&
        !this.props.datosProcesoCarritoAccP.procesoCarritoAccPhasError
      ) {


        if (nombreProducto2 == 'Guardias') {
          this.props.history.push({
            pathname: "/vigencia-cotizacion-accidente-personal",
            search: "?idCarrito=" + this.state.idCarrito,
          });
        } else {
          this.props.history.push({
            pathname: "/detalle-cotizacion-accidente-personal",
            search: "?idCarrito=" + this.state.idCarrito,
          });
        }
      }
    } else {
      //console.log('ERROOR')
      this.setState({
        errorCantidad: true,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.state !== this.state) {
    }
  }

  async onClickRegresar(e) {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarritoUrl = queryParams.get("id");

    //se obtiene el id del carrito de la url o del stateLocal

    let idCarrito = "";

    if (
      idCarritoUrl !== undefined &&
      idCarritoUrl !== null &&
      idCarritoUrl !== ""
    ) {
      idCarrito = idCarritoUrl;
    } else {
      idCarrito = this.props.datosCarritoAccP.productoAccP.idCarrito;
    }

    if (idCarrito === undefined || idCarrito === null || idCarrito === "") {
      idCarrito = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .mongoCarrito;
    }

    this.props.history.replace({
      pathname: `/cotizacion-accidente-personal`,
      search: "?id=" + idCarrito,
    });
  }

  asignarNumeroPersonas(e, opcion, plan) {
    let val = e.target.value;
    let valor = val.replace(".", "");

    this.setState({
      errorCantidad: false,
    });

    let datosPersonas = this.state.estructura.datosPersonas;
    let index = datosPersonas.findIndex((data) => data.planListado === plan);

    let estructuraAux = this.state.estructura.datosPersonas;
    //estructuraAux[index].valores[opcion-1].numPersonas = e.target.value
    estructuraAux[index].valores[opcion - 1].numPersonas = valor;
    this.setState({
      [this.state.estructura.datosPersonas]: estructuraAux,
    });

    //console.log('deberia ser', this.state.estructura.datosPersonas[index].valores[opcion-1].numPersonas)
  }

  async componentDidMount() {
    //console.clear();
    window.scroll(0, 0);

    let datosPersonas = [];

    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarritoUrl = queryParams.get("id");

    //se obtiene el id del carrito de la url o del stateLocal
    let idCarrito = "";

    if (
      idCarritoUrl !== undefined &&
      idCarritoUrl !== null &&
      idCarritoUrl !== ""
    ) {
      idCarrito = idCarritoUrl;
    } else {
      idCarrito = this.props.datosCarritoAccP.productoAccP.idCarrito;
    }

    if (idCarrito === undefined || idCarrito === null || idCarrito === "") {
      idCarrito = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .mongoCarrito;
    }

    this.setState({
      idCarrito,
    });

    await this.props.recuperarCarrito({
      empresa: "AIGMETROPOLITANA",
      idCarrito,
    });

    const dataPlan = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
      .carProductos[0];
    let _this = this;
    this.props.datosCoberturasAP.map((cob) => {
      let arrayValores = cob.valores[0].valores;
      _this.setState({ countValores: arrayValores.length });
      console.log("arrayValores", arrayValores);
      let valores = [];
      arrayValores.forEach((info) => {
        const valor = { codOpcion: info.codOpcion, numPersonas: "0" };
        valores.push(valor);
      });
      let arrayBase = {
        planListado: "",
        valores: valores,
      };
      arrayBase.planListado = cob.planListado;
      datosPersonas.push(arrayBase);
    });

    //Validar si se debe distribuir las personas o se debe mostrar un boton
    let mostrarDistribucion = "";
    if (dataPlan && dataPlan.distribucionPersonas) {
      mostrarDistribucion = dataPlan.distribucionPersonas;
    }

    //  dataPlan.plan.name

    this.setState({
      estructura: {
        empresa: "AIGMETROPOLITANA",
        pasoCarrito: "guardarDataCobertura",
        idCarrito: idCarrito,
        codigoProductoActual: dataPlan.codigo,
        datosPersonas: datosPersonas,
      },
      numPersonas: dataPlan.numPersonasTotal,
      loading: false,
      mostrarDistribucionPersonas: mostrarDistribucion,
    });

    if (
      dataPlan.datosNumPersonasOpcion &&
      idCarritoUrl !== undefined &&
      idCarritoUrl !== null &&
      idCarritoUrl !== ""
    ) {
      this.setState({
        estructura: {
          empresa: "AIGMETROPOLITANA",
          pasoCarrito: "guardarDataCobertura",
          idCarrito: idCarrito,
          codigoProductoActual: dataPlan.codigo,
          datosPersonas: dataPlan.datosNumPersonasOpcion,
        },
      });
    }

    //console.log('verifica en este punto', this.state.estructura)

    console.log("this.props", this.props);
    console.log("this.propscobeturas", this.props.datosCoberturasAP);
    console.log("datosPersonas", this.state.estructura.datosPersonas);
  }



  render() {
    const {
      selPlan,
      numDias,
      validate,
      errorCantidad,
      mostrarDistribucionPersonas
    } = this.state;
    //console.log(this.state);
    let isLoading =
      this.props.datosRecuperarCarritoAccP.recuperarCarritoAccPIsLoading ||
      this.state.loading;


    return (
      <LoadingScreen
        loading={isLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        <Page
          title="Cotización Accidentes Personales"
          breadcrumbs={[{ name: "Cotización Accidentes", active: true }]}
        >
          <div className="container-step ">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>

          <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
            <Row className="menu-superior-pantallas-grandes">
              <Col lg={11} md={12} sm={12} xs={12} className="div-align-center">
                <Card className="flex-row ">
                  <CardBody>
                    <h3 style={{ fontWeight: "bold", textAlign: "center" }}>
                      Tabla de coberturas
                    </h3>
                    {/*  <p style={{ fontWeight: "300", textAlign: "center"}}>
                      A continuación se detalla una tabla comparativa de las
                      coberturas y beneficios de nuestros productos para su
                      selección
    </p>  */}

                    {this.props.datosCoberturasAP &&
                      this.props.datosCoberturasAP.map((cob, index) => (


                        <>
                          <Col
                            lg={11}
                            md={11}
                            sm={11}
                            xs={11}
                            className="div-align-center"
                          >
                            <h3
                              style={{ fontWeight: "bold", textAlign: "left" }}
                            >
                              {
                                this.props.datosRecuperarCarritoAccP &&
                                  this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP &&
                                  this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                                    .carProductos &&
                                  this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                                    .carProductos[0] &&
                                  this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                                    .carProductos[0].plan ?
                                  this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                                    .carProductos[0].plan.descripcion.toUpperCase() : ''}
                            </h3>
                          </Col>
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="div-align-center"
                          >
                            {/* Armado de Cabecera de Tabla COmparativa de Cobertura y Beneficios */}
                            <Row className="mb-2">
                              <Col
                                lg={2}
                                md={3}
                                sm={3}
                                xs={3}
                                className="div-align-center"
                                style={{ backgroundColor: "#a8a8aa" }}
                              >
                                <h2
                                  style={this.state.countValores < 4 ? {
                                    fontSize: 'medium',
                                    color: "#001871",
                                    textAlign: "center",


                                  } : {
                                    fontSize: 'small',
                                    color: "#001871",
                                    textAlign: "center",
                                    padding: "6px",

                                  }}
                                >
                                  COBERTURA Y BENEFICIOS
                                </h2>
                              </Col>
                              {cob.valores !== undefined &&
                                cob.valores[0] &&
                                cob.valores[0].valores.map((prima, i) => {
                                  let count = cob.valores[0].valores.length;

                                  var codigoActividadAigmed = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0] && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed ? this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed.codigo1 : null


                                  return ((cob.planListado.toUpperCase() == 'AIGMED' && prima.codOpcion == codigoActividadAigmed) || cob.planListado.toUpperCase() != 'AIGMED') ? <AccPersonalTooltip
                                    key={i} prima={prima} id={i} count={count}>
                                  </AccPersonalTooltip> : null;
                                })}


                            </Row>

                            {/* Leer todo el array de coberturas y beneficios */}

                            {cob.coberturas !== undefined &&
                              cob.coberturas.map((cobertura) => {
                                let tamfuente = "large";
                                let margen = "0px 0px 0px 0px";
                                if (cobertura.padre !== "") {
                                  tamfuente = "100";
                                  margen = "0px 0px 0px 20px";
                                }
                                let content = "";
                                let valValores = true;
                                if (cobertura.valores.length > 0) {
                                  let count = cobertura.valores.length;
                                  console.log("countd", count);
                                  content = cobertura.valores.map((val) => {

                                    var codigoActividadAigmed = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0] && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed ? this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed.codigo1 : null


                                    return ((cob.planListado.toUpperCase() == 'AIGMED' && val.codOpcion == codigoActividadAigmed) || cob.planListado.toUpperCase() != 'AIGMED') ? <Col
                                      lg={count < 4 ? 2 : 0}
                                      md={count < 4 ? 3 : 0}
                                      sm={count < 4 ? 3 : 0}
                                      xs={count < 4 ? 3 : 0}
                                      className="div-align-center"
                                    >
                                      <div
                                        style={{
                                          backgroundColor: "#d1d0ce",
                                          wordBreak: 'break-all', textAlign: "center", alignItems: "center"
                                        }}
                                      >
                                        <p
                                          style={
                                            count < 4
                                              ? {
                                                fontWeight: "large",
                                                textAlign: "center",
                                                padding: "10px 10px",
                                              }
                                              : {
                                                fontSize: "small",
                                                textAlign: "center",
                                                padding: "10px 10px",
                                              }
                                          }
                                        >
                                          {val.valor}
                                        </p>
                                      </div>
                                    </Col> : null
                                  });
                                } else {
                                  valValores = false;
                                }



                                return (
                                  <Row className="mb-2">
                                    <Col
                                      lg={2}
                                      md={3}
                                      sm={3}
                                      xs={3}
                                      className="div-align-center"
                                      style={{ backgroundColor: "#d1d0ce" }}
                                    >
                                      <div>
                                        <p
                                          style={this.state.countValores < 4 ? {
                                            fontSize: 'medium',
                                            padding: `${margen}`,
                                          } : {
                                            fontSize: 'small',
                                            textAlign: "justify",

                                          }}
                                        >
                                          {cobertura.nombreCobertura}
                                        </p>
                                      </div>
                                    </Col>
                                    {!valValores && (
                                      <Col
                                        lg={2}
                                        md={3}
                                        sm={3}
                                        xs={3}
                                        className="div-align-center"
                                        style={{ backgroundColor: "#d1d0ce" }}
                                      >
                                        <p> </p>
                                      </Col>
                                    )}
                                    {!valValores && (
                                      <Col
                                        lg={2}
                                        md={3}
                                        sm={3}
                                        xs={3}
                                        className="div-align-center"
                                        style={{ backgroundColor: "#d1d0ce" }}
                                      >
                                        <p> </p>
                                      </Col>
                                    )}
                                    {content}
                                  </Row>
                                );
                              })}
                            {/* renderizar la tabla de opcioens con los valores */}
                            <Row>
                              <Col
                                lg={2}
                                md={3}
                                sm={3}
                                xs={3}
                                className="div-align-center"
                              ></Col>
                              {cob.valores !== undefined &&
                                cob.valores[0] &&
                                cob.valores[0].valores.map((prima, i) => {
                                  let count = cob.valores[0].valores.length;
                                  var codigoActividadAigmed = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0] && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed ? this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed.codigo1 : null

                                  return ((cob.planListado.toUpperCase() == 'AIGMED' && prima.codOpcion == codigoActividadAigmed) || cob.planListado.toUpperCase() != 'AIGMED') ? <AccPersonalTooltip
                                    key={i} prima={prima} id={i} count={count}>
                                  </AccPersonalTooltip> : null;
                                })}
                            </Row>
                            {/* CARGAR DINAMICAMENTE LA TABAL DE VALORES/ */}

                            {cob.valores !== undefined &&
                              cob.valores.map((item) => {
                                let count = cob.valores.length;
                                console.log("valorescout", count);
                                return (
                                  <Row className="mb-2">
                                    <Col
                                      lg={count < 4 ? 2 : 0}
                                      md={count < 4 ? 3 : 0}
                                      sm={count < 4 ? 3 : 0}
                                      xs={count < 4 ? 3 : 0}
                                      className="div-align-center"
                                      style={{ backgroundColor: "#a8a8aa" }}
                                    >
                                      <h5 style={this.state.countValores < 4 ? { fontWeight: "normal" } : {
                                        fontSize: 'medium'

                                      }}>
                                        {item.nombreCobertura.toUpperCase()}
                                      </h5>
                                    </Col>
                                    {item.valores !== undefined &&
                                      item.valores.map((prima) => {
                                        let count = item.valores.length;
                                        var codigoActividadAigmed = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0] && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed ? this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed.codigo1 : null
                                        console.log("itemcount", count);

                                        var primaSuma = 0

                                        if (prima.nomOpcion == 'Guardias Horas Laborables') {
                                          const valorPrimaHorasLaborables = parseFloat(prima.valorDecimales)


                                          const primaHorasNoLaborables = item.valores.find(prima => prima.nomOpcion == 'Guardias Horas No Laborables')

                                          const personalAdministrativo = item.valores.find(prima => prima.nomOpcion == 'Personal Administrativo')



                                          const valorPrimaHorasNoLaborables = primaHorasNoLaborables ? parseFloat(primaHorasNoLaborables.valorDecimales) : 0

                                          const valorPersonalAdministrativo = personalAdministrativo ? parseFloat(personalAdministrativo.valorDecimales) : 0

                                          primaSuma = valorPrimaHorasLaborables + valorPrimaHorasNoLaborables


                                        }
                                        return ((cob.planListado.toUpperCase() == 'AIGMED' && prima.codOpcion == codigoActividadAigmed) || cob.planListado.toUpperCase() != 'AIGMED') ? (
                                          <Col
                                            lg={count < 4 ? 2 : 0}
                                            md={count < 4 ? 3 : 0}
                                            sm={count < 4 ? 3 : 0}
                                            xs={count < 4 ? 3 : 0}
                                            className="div-align-center"
                                          >

                                            {/* {JSON.stringify(prima)} */}

                                            <div
                                              style={{
                                                backgroundColor: "#a8a8aa",
                                                height: '60px',
                                                width:
                                                  prima.nomOpcion == 'Guardias Horas Laborables' ? '265%' :
                                                    prima.nomOpcion == 'Guardias Horas No Laborables' ? '0px' :
                                                      null
                                              }}
                                            >
                                              <h2
                                                style={
                                                  count < 4
                                                    ? {
                                                      fontWeight: "bold",
                                                      color: "#af006e",
                                                      textAlign: "center",
                                                      textTransform:
                                                        "uppercase",
                                                      padding: "6px",
                                                      fontSize: prima.nomOpcion == 'Personal Administrativo' ? '15px' : null
                                                    }
                                                    : {
                                                      fontWeight: "bold",
                                                      color: "#af006e",
                                                      textAlign: "center",
                                                      textTransform:
                                                        "uppercase",
                                                      padding: "10px 10px",
                                                      fontSize: "small",
                                                    }
                                                }
                                              >


                                                {
                                                  prima.nomOpcion == 'Guardias Horas Laborables' ?
                                                    `$${primaSuma.toFixed(2)}` :

                                                    prima.nomOpcion == 'Personal Administrativo' ?
                                                      `Gratis hasta el 10% de guardias asegurados` :


                                                      prima.nomOpcion != 'Guardias Horas No Laborables' ?
                                                        `$${prima.valor}` :
                                                        null}

                                              </h2>
                                            </div>
                                          </Col>
                                        ) : null;
                                      })}
                                  </Row>
                                );
                              })}

                            {/* <Row className="mb-2">
                            <Col
                              lg={3}
                              md={3}
                              sm={3}
                              xs={3}
                              className="div-align-center"
                              style={{ backgroundColor: "#a8a8aa" }}
                            >
                              <h5 style={{ fontWeight: "normal" }}>
                                PRIMA NETA ANUAL POR PERSONA
                              </h5>
                            </Col>
                            {cob.valores !== undefined &&
                              cob.valores.map(prima => {
                                return (
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={3}
                                    xs={3}
                                    className="div-align-center"
                                  >
                                    <div style={{ backgroundColor: "#a8a8aa" }}>
                                      <h2
                                        style={{
                                          fontWeight: "bold",
                                          color: "#af006e",
                                          textAlign: "center",
                                          textTransform: "uppercase",
                                          padding: "6px"
                                        }}
                                      >
                                        ${prima.primaNetaAnual}
                                      </h2>
                                    </div>
                                  </Col>
                                );
                              })}
                          </Row> */}
                            {/* <Row className="mb-2">
                            <Col
                              lg={3}
                              md={3}
                              sm={3}
                              xs={3}
                              className="div-align-center"
                              style={{ backgroundColor: "#a8a8aa" }}
                            >
                              <h5 style={{ fontWeight: "normal" }}>
                                PRIMA TOTAL ANUAL POR PERSONA
                              </h5>
                            </Col>
                            {cob.valores !== undefined &&
                              cob.valores.map(prima => {
                                return (
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={3}
                                    xs={3}
                                    className="div-align-center"
                                  >
                                    <div style={{ backgroundColor: "#a8a8aa" }}>
                                      <h2
                                        style={{
                                          fontWeight: "bold",
                                          color: "#af006e",
                                          textAlign: "center",
                                          textTransform: "uppercase",
                                          padding: "6px"
                                        }}
                                      >
                                        ${prima.primaTotalAnual}
                                      </h2>
                                    </div>
                                  </Col>
                                );
                              })}
                          </Row> */}
                            {/* <Row className="mb-2">
                            <Col
                              lg={3}
                              md={3}
                              sm={3}
                              xs={3}
                              className="div-align-center"
                              style={{ backgroundColor: "#a8a8aa" }}
                            >
                              <h5 style={{ fontWeight: "normal" }}>
                                PRIMA NETA MENSUAL POR PERSONA
                              </h5>
                            </Col>
                            {cob.valores !== undefined &&
                              cob.valores.map(prima => {
                                return (
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={3}
                                    xs={3}
                                    className="div-align-center"
                                  >
                                    <div style={{ backgroundColor: "#a8a8aa" }}>
                                      <h2
                                        style={{
                                          fontWeight: "bold",
                                          color: "#af006e",
                                          textAlign: "center",
                                          textTransform: "uppercase",
                                          padding: "6px"
                                        }}
                                      >
                                        ${prima.primaNetaMensual}
                                      </h2>
                                    </div>
                                  </Col>
                                );
                              })}
                          </Row> */}
                            {/* <Row className="mb-2">
                            <Col
                              lg={3}
                              md={3}
                              sm={3}
                              xs={3}
                              className="div-align-center"
                              style={{ backgroundColor: "#a8a8aa" }}
                            >
                              <h5 style={{ fontWeight: "normal" }}>
                                PRIMA TOTAL MENSUAL POR PERSONA
                              </h5>
                            </Col>
                            {cob.valores !== undefined &&
                              cob.valores.map(prima => {
                                return (
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={3}
                                    xs={3}
                                    className="div-align-center"
                                  >
                                    <div style={{ backgroundColor: "#a8a8aa" }}>
                                      <h2
                                        style={{
                                          fontWeight: "bold",
                                          color: "#af006e",
                                          textAlign: "center",
                                          textTransform: "uppercase",
                                          padding: "6px"
                                        }}
                                      >
                                        ${prima.primaTotalMensual}
                                      </h2>
                                    </div>
                                  </Col>
                                );
                              })}
                          </Row> */}
                            <Row className="mb-5">
                              <Col
                                lg={2}
                                md={3}
                                sm={3}
                                xs={3}
                                className="div-align-center"
                              >
                                {mostrarDistribucionPersonas === "1"
                                  ? "Número de Personas a Asegurar"
                                  : mostrarDistribucionPersonas === "2"
                                    ? "Seleccione un Plan para Continuar"
                                    : ""}
                              </Col>
                              {cob.valores !== undefined &&
                                this.state.estructura &&
                                this.state.estructura.datosPersonas &&
                                this.state.estructura.datosPersonas[index] &&
                                this.state.estructura.datosPersonas[index]
                                  .valores &&
                                this.state.estructura.datosPersonas[index]
                                  .valores &&
                                cob.valores[0].valores.map((prima) => {
                                  let count = cob.valores[0].valores.length;
                                  var codigoActividadAigmed = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed.codigo1
                                  return ((cob.planListado.toUpperCase() == 'AIGMED' && prima.codOpcion == codigoActividadAigmed) || cob.planListado.toUpperCase() != 'AIGMED') ? (
                                    <Col
                                      lg={count < 4 ? 2 : 0}
                                      md={count < 4 ? 3 : 0}
                                      sm={count < 4 ? 3 : 0}
                                      xs={count < 4 ? 3 : 0}
                                      className="div-align-center"
                                    >
                                      <div className="form-group">
                                        {mostrarDistribucionPersonas ===
                                          "1" && (
                                            <input
                                              type="number"
                                              className="form-control"
                                              id="usr"
                                              value={
                                                this.state.estructura
                                                  .datosPersonas[index].valores[
                                                  prima.codOpcion - 1
                                                ].numPersonas === ""
                                                  ? ""
                                                  : parseInt(
                                                    this.state.estructura
                                                      .datosPersonas[index]
                                                      .valores[
                                                      prima.codOpcion - 1
                                                    ].numPersonas
                                                  )
                                              }
                                              onChange={(e) =>
                                                this.asignarNumeroPersonas(
                                                  e,
                                                  prima.codOpcion,
                                                  cob.planListado
                                                )
                                              }
                                            />
                                          )}
                                        {mostrarDistribucionPersonas ===
                                          "2" && (
                                            <Button
                                              className="btn btn-primary"
                                              onClick={(e) =>
                                                this.validateForm(
                                                  e,
                                                  prima.codOpcion
                                                )
                                              }
                                              style={{
                                                display: "block",
                                                margin: "auto",
                                              }}
                                            >
                                              <i
                                                className="fa fa-check"
                                                aria-hidden="true"
                                              />{" "}
                                              {"SELECCIONAR"}
                                            </Button>
                                          )}
                                      </div>
                                    </Col>
                                  ) : null;
                                })}
                            </Row>
                          </Col>
                        </>
                      ))}

                    <Row>
                      <Col xs={12}>
                        {errorCantidad && (
                          <Alert
                            color="danger"
                            isOpen={this.state.errorCantidad}
                            toggle={this.onDismiss}
                          >
                            <center>
                              <p>
                                La suma total de personas distribuidas de cada plan no debe ser mayor a  {this.state.numPersonas}
                              </p>
                            </center>
                          </Alert>
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="div-align-center"
                      >
                        <Button
                          className="btn btn-detail-gray"
                          onClick={this.onClickRegresar}
                        >
                          <i
                            className="fa fa-chevron-circle-left"
                            aria-hidden="true"
                          />{" "}
                          {"REGRESAR"}
                        </Button>
                      </Col>

                      <Col
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="div-align-center"
                      >
                        {(mostrarDistribucionPersonas === "1" ||
                          mostrarDistribucionPersonas === "3") && (
                            <Button
                              className="btn btn-primary"
                              onClick={this.validateForm}
                              style={{
                                display: "block",
                                margin: "auto",
                                float: "right",
                              }}
                            >
                              <i
                                className="fa fa-chevron-circle-right"
                                aria-hidden="true"
                              />{" "}
                              {"CONTINUAR"}
                            </Button>
                          )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="menu-superior-pantallas-pequenas">
              <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                <Card className="flex-row ">
                  <CardBody>
                    <h3
                      style={{
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Tabla de coberturas
                    </h3>
                    {/*   <p style={{ fontWeight: "300", textAlign: "center" }}>
                      A continuación se detalla una tabla comparativa de las
                      coberturas y beneficios de nuestros productos para su
                      selección
                    </p>  */}

                    {this.props.datosCoberturasAP.map((cob, index) => (
                      <>
                        <Row className="mb-3">
                          <Col
                            lg={11}
                            md={11}
                            sm={11}
                            xs={11}
                            className="div-align-center"
                          >
                            <h3
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              {

                                this.props.datosRecuperarCarritoAccP
                                  && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                                  && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                                  && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos
                                  && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0]
                                  && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].plan
                                  && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].plan.descripcion

                                  ?

                                  this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                                    .carProductos[0].plan.descripcion.toUpperCase()
                                  : ''



                              }
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Row className="mb-2">
                              <Col lg={12} md={12} sm={12} xs={12}>
                                <Col
                                  lg={10}
                                  md={10}
                                  sm={10}
                                  xs={10}
                                  className="div-align-center"
                                  style={{ backgroundColor: "#a8a8aa" }}
                                >
                                  <h2
                                    style={{
                                      fontWeight: "large",
                                      color: "#001871",
                                      textAlign: "center",
                                    }}
                                  >
                                    COBERTURA Y BENEFICIOS
                                  </h2>
                                </Col>
                              </Col>
                            </Row>

                            {cob.coberturas !== undefined &&
                              cob.coberturas.map((cobertura) => {
                                let tamfuente = "large";
                                let margen = "0px 0px 0px 0px";
                                if (cobertura.padre !== "") {
                                  tamfuente = "100";
                                  margen = "0px 0px 0px 20px";
                                }
                                let content2 = "";
                                if (cobertura.valores.length > 0) {
                                  content2 = cobertura.valores.map((val) => (
                                    <Col
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{
                                          backgroundColor: "rgb(0, 115, 174)",
                                        }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "large",
                                            color: "white",
                                            textAlign: "center",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {val.nomOpcion}
                                        </h2>
                                      </Col>
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{ backgroundColor: "#d1d0ce" }}
                                      >
                                        <p
                                          style={{
                                            fontWeight: "large",
                                            textAlign: "center",
                                          }}
                                        >
                                          {val.valor}
                                        </p>
                                      </Col>
                                    </Col>
                                  ));
                                }
                                return (
                                  <Row className="mb-3">
                                    <Col
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{
                                          backgroundColor: "#a8a8aa",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: "#af006e",
                                            fontWeight: `${tamfuente}`,
                                            padding: `${margen}`,
                                          }}
                                        >
                                          {cobertura.nombreCobertura}
                                        </p>
                                      </Col>
                                    </Col>
                                    {content2}
                                  </Row>
                                );
                              })}

                            {/* CARGAR DINAMICAMENTE LA TABAL DE VALORES/ */}
                            {Object.keys(cob).length > 0 &&
                              cob.valores.map((item) => {
                                return (
                                  <div>
                                    <Row className="mt-5">
                                      <Col lg={12} md={12} sm={12} xs={12}>
                                        <Col
                                          lg={10}
                                          md={10}
                                          sm={10}
                                          xs={10}
                                          className="div-align-center"
                                          style={{ backgroundColor: "#a8a8aa" }}
                                        >
                                          <h3 style={{ fontWeight: "normal" }}>
                                            {item.nombreCobertura.toUpperCase()}
                                          </h3>
                                        </Col>
                                      </Col>
                                    </Row>
                                    {item.valores &&
                                      item.valores.map((prima) => {

                                        return (
                                          <Row>
                                            <Col
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              style={{ marginBottom: "0px" }}
                                            >
                                              <Col
                                                lg={10}
                                                md={10}
                                                sm={10}
                                                xs={10}
                                                className="div-align-center"
                                                style={{
                                                  backgroundColor:
                                                    "rgb(0, 115, 174)",
                                                }}
                                              >
                                                <h2
                                                  style={{
                                                    fontWeight: "large",
                                                    color: "white",
                                                    textAlign: "center",
                                                    textTransform: "uppercase",
                                                  }}
                                                >
                                                  {prima.nomOpcion}

                                                </h2>
                                              </Col>
                                              <Col
                                                lg={10}
                                                md={10}
                                                sm={10}
                                                xs={10}
                                                className="div-align-center"
                                                style={{
                                                  backgroundColor: "#d1d0ce",
                                                }}
                                              >
                                                <h2
                                                  style={{
                                                    fontWeight: "bold",
                                                    color: "#af006e",
                                                    textAlign: "center",
                                                    textTransform: "uppercase",
                                                  }}
                                                >
                                                  ${prima.valor}
                                                </h2>
                                              </Col>
                                            </Col>
                                          </Row>
                                        );
                                      })}
                                  </div>
                                );
                              })}

                            {/* 
                            <Row className="mt-5">
                              <Col lg={12} md={12} sm={12} xs={12}>
                                <Col
                                  lg={10}
                                  md={10}
                                  sm={10}
                                  xs={10}
                                  className="div-align-center"
                                  style={{ backgroundColor: "#a8a8aa" }}
                                >
                                  <h3 style={{ fontWeight: "normal" }}>
                                    PRIMA NETA ANUAL POR PERSONA
                                  </h3>
                                </Col>
                              </Col>
                            </Row>
                            {Object.keys(cob).length > 0 &&
                              cob.valores.map(prima => {
                                return (
                                  <Row>
                                    <Col
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{
                                          backgroundColor: "rgb(0, 115, 174)"
                                        }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "large",
                                            color: "white",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          {prima.nombreOpcion}
                                        </h2>
                                      </Col>
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{ backgroundColor: "#d1d0ce" }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "bold",
                                            color: "#af006e",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          ${prima.primaNetaAnual}
                                        </h2>
                                      </Col>
                                    </Col>
                                  </Row>
                                );
                              })} */}

                            {/* <Row className="mt-5">
                              <Col lg={12} md={12} sm={12} xs={12}>
                                <Col
                                  lg={10}
                                  md={10}
                                  sm={10}
                                  xs={10}
                                  className="div-align-center"
                                  style={{ backgroundColor: "#a8a8aa" }}
                                >
                                  <h3 style={{ fontWeight: "normal" }}>
                                    PRIMA TOTAL ANUAL POR PERSONA
                                  </h3>
                                </Col>
                              </Col>
                            </Row>
                            {Object.keys(cob).length > 0 &&
                              cob.valores.map(prima => {
                                return (
                                  <Row>
                                    <Col
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{
                                          backgroundColor: "rgb(0, 115, 174)"
                                        }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "large",
                                            color: "white",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          {prima.nombreOpcion}
                                        </h2>
                                      </Col>
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{ backgroundColor: "#d1d0ce" }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "bold",
                                            color: "#af006e",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          ${prima.primaTotalAnual}
                                        </h2>
                                      </Col>
                                    </Col>
                                  </Row>
                                );
                              })} */}

                            {/* <Row className="mt-5">
                              <Col lg={12} md={12} sm={12} xs={12}>
                                <Col
                                  lg={10}
                                  md={10}
                                  sm={10}
                                  xs={10}
                                  className="div-align-center"
                                  style={{ backgroundColor: "#a8a8aa" }}
                                >
                                  <h3 style={{ fontWeight: "normal" }}>
                                    PRIMA NETA MENSUAL POR PERSONA
                                  </h3>
                                </Col>
                              </Col>
                            </Row>
                            {Object.keys(cob).length > 0 &&
                              cob.valores.map(prima => {
                                return (
                                  <Row>
                                    <Col
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{
                                          backgroundColor: "rgb(0, 115, 174)"
                                        }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "large",
                                            color: "white",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          {prima.nombreOpcion}
                                        </h2>
                                      </Col>
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{ backgroundColor: "#d1d0ce" }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "bold",
                                            color: "#af006e",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          ${prima.primaNetaMensual}
                                        </h2>
                                      </Col>
                                    </Col>
                                  </Row>
                                );
                              })} */}

                            {/* <Row className="mt-5">
                              <Col lg={12} md={12} sm={12} xs={12}>
                                <Col
                                  lg={10}
                                  md={10}
                                  sm={10}
                                  xs={10}
                                  className="div-align-center"
                                  style={{ backgroundColor: "#a8a8aa" }}
                                >
                                  <h3 style={{ fontWeight: "normal" }}>
                                    PRIMA TOTAL MENSUAL POR PERSONA
                                  </h3>
                                </Col>
                              </Col>
                            </Row>
                            {Object.keys(cob).length > 0 &&
                              cob.valores.map(prima => {
                                return (
                                  <Row>
                                    <Col
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{
                                          backgroundColor: "rgb(0, 115, 174)"
                                        }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "large",
                                            color: "white",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          {prima.nombreOpcion}
                                        </h2>
                                      </Col>
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{ backgroundColor: "#d1d0ce" }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "bold",
                                            color: "#af006e",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                          }}
                                        >
                                          ${prima.primaTotalMensual}
                                        </h2>
                                      </Col>
                                    </Col>
                                  </Row>
                                );
                              })} */}

                            <Row className="mt-5">
                              <Col lg={12} md={12} sm={12} xs={12}></Col>
                            </Row>
                            {mostrarDistribucionPersonas !== "3" &&
                              Object.keys(cob).length > 0 &&
                              cob.valores[0].valores.map((prima) => {
                                var codigoActividadAigmed = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0] && this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed ? this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].actividadAigmed.codigo1 : null
                                return ((cob.planListado.toUpperCase() == 'AIGMED' && prima.codOpcion == codigoActividadAigmed) || cob.planListado.toUpperCase() != 'AIGMED') ? (
                                  <Row>
                                    <Col
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                        style={{
                                          backgroundColor: "rgb(0, 115, 174)",
                                        }}
                                      >
                                        <h2
                                          style={{
                                            fontWeight: "large",
                                            color: "white",
                                            textAlign: "center",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {prima.nomOpcion}
                                        </h2>
                                      </Col>

                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="div-align-center"
                                      >
                                        <div className="form-group">
                                          {mostrarDistribucionPersonas ===
                                            "1" &&
                                            cob.valores !== undefined &&
                                            this.state.estructura &&
                                            this.state.estructura
                                              .datosPersonas &&
                                            this.state.estructura.datosPersonas[
                                            index
                                            ] &&
                                            this.state.estructura.datosPersonas[
                                              index
                                            ].valores &&
                                            this.state.estructura.datosPersonas[
                                              index
                                            ].valores && (
                                              <input
                                                type="number"
                                                className="form-control"
                                                id="usr"
                                                value={
                                                  this.state.estructura
                                                    .datosPersonas[index]
                                                    .valores[
                                                    prima.codOpcion - 1
                                                  ].numPersonas === ""
                                                    ? ""
                                                    : parseInt(
                                                      this.state.estructura
                                                        .datosPersonas[index]
                                                        .valores[
                                                        prima.codOpcion - 1
                                                      ].numPersonas
                                                    )
                                                }
                                                onChange={(e) =>
                                                  this.asignarNumeroPersonas(
                                                    e,
                                                    prima.codOpcion,
                                                    cob.planListado
                                                  )
                                                }
                                              />
                                            )}

                                          {mostrarDistribucionPersonas ===
                                            "2" && (
                                              <Button
                                                className="btn btn-primary"
                                                onClick={(e) =>
                                                  this.validateForm(
                                                    e,
                                                    prima.codOpcion
                                                  )
                                                }
                                                style={{
                                                  display: "block",
                                                  margin: "auto",
                                                }}
                                              >
                                                <i
                                                  className="fa fa-check"
                                                  aria-hidden="true"
                                                />{" "}
                                                {"SELECCIONAR"}
                                              </Button>
                                            )}
                                        </div>
                                      </Col>
                                    </Col>
                                  </Row>
                                ) : null;
                              })}
                          </Col>
                        </Row>
                      </>
                    ))}

                    <Row>
                      <Col xs={12}>
                        {errorCantidad && (
                          <Alert
                            color="danger"
                            isOpen={this.state.errorCantidad}
                            toggle={this.onDismiss}
                          >
                            <center>
                              <p>
                                La suma total de personas distribuidas de cada plan no debe ser mayor a {this.state.numPersonas}
                              </p>
                            </center>
                          </Alert>
                        )}
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="div-align-center"
                      >
                        <Button
                          className="btn btn-detail-gray"
                          onClick={this.onClickRegresar}
                          style={{ display: "block", margin: "auto" }}
                        >
                          <i
                            className="fa fa-chevron-circle-left"
                            aria-hidden="true"
                          />
                          {" REGRESAR"}
                        </Button>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="div-align-center"
                      >
                        {(mostrarDistribucionPersonas === "1" ||
                          mostrarDistribucionPersonas === "3") && (
                            <Button
                              className="btn btn-primary"
                              onClick={this.validateForm}
                              style={{
                                display: "block",
                                margin: "auto",
                              }}
                            >
                              <i
                                className="fa fa-chevron-circle-right"
                                aria-hidden="true"
                              />{" "}
                              {"CONTINUAR"}
                            </Button>
                          )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>

          <Row>
            <Col lg={10} md={10} sm={12} xs={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <Row style={{ margin: "3px" }}>
                    <h5 style={{ fontWeight: "large" }}>
                      {/* Nota: Los limites expuestos se encuentran en dólares                      
                      americanos. Las primas antes mencionadas incluyen
                      impuestos de ley. */}
                      {this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                        .carProductos[0] &&
                        this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                          .carProductos[0].mensajeCobertura
                        ? this.props.datosRecuperarCarritoAccP
                          .recuperarCarritoAccP.carProductos[0]
                          .mensajeCobertura
                        : ""}
                    </h5>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosCarritoAccP: state.datosCarritoAccP,
  datosRecuperarCarritoAccP: state.datosRecuperarCarritoAccP,
  datosProcesoCarritoAccP: state.datosProcesoCarritoAccP,
});

const mapDispatchToProps = (dispatch) => {
  return {
    procesoCarrito: (datos) => dispatch(fetchProcesoCarritoAccP(datos)),
    recuperarCarrito: (datos) => dispatch(fetchRecuperarCarritoAccP(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizacionAccPersonal2)
);
